import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class ZoneRepository<ZoneModel> extends RepositoryBase<ZoneModel> {
    public constructor() {
        super('zone');
    }
}
